module.exports = __webpack_public_path__ + "static/v3-118275475eae2b4801997a960cb28628.png";